import React, {Component} from 'react';
import { Navbar, Nav, Form, Button, Dropdown, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faPlus, faSave, faSignInAlt, faSignOutAlt, faTable, faCog, faCogs, faLayerGroup, faThList, faTractor } from "@fortawesome/free-solid-svg-icons";
import {ROLE_ADMIN, ROLE_SUPER_ADMIN, ROLE_MEMBER} from './auth/Auth';
import { Logo } from "./admin/Logo";
import logoNoText from '../assets/img/ls_logo_print_square.png';
import datumLogoNoText from '../assets/img/datum_logo_notext.svg';

class Navigation extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.navOnSaveDashboard = this.navOnSaveDashboard.bind(this);
    this.navOnAddWidget = this.navOnAddWidget.bind(this);
  }

  navOnAddWidget() {
    const { onAddWidget } = this.props;
    if (onAddWidget) {
      onAddWidget();
    }
  }  

  navOnSaveDashboard() {
    const { onSaveDashboard } = this.props;
    if (onSaveDashboard) {
      onSaveDashboard();
    }
  }
  
  renderTooltip(messageTooltip:String){
    return <Tooltip id="button-tooltip">
             {messageTooltip}
            </Tooltip>
  }

  renderAdminButtons(_currentUser:any) {
    const { isPublic } = this.props;
    if (isPublic) {
      return '';
    }
    if (_currentUser.roleId === ROLE_ADMIN || _currentUser.roleId === ROLE_SUPER_ADMIN || _currentUser.roleId === ROLE_MEMBER ) {
      return  <span key="with-super-admin">
              <OverlayTrigger placement="bottom" delay={{ show: 100, hide: 200 }} overlay={this.renderTooltip("Field Manager")}>
                  <Button className="dashboard-icon-button" variant="secondary" key="dashboard-list" href={`${process.env.REACT_APP_FIELD_MGR_ROOT_URL}`}>
                    {/*<FontAwesomeIcon icon={faTractor} />*/}
                    <div className="d-flex justify-content-around nav navbar-logo-parent" style={{ backgroundColor: "white", padding: "1.5px" }}>
                      <img
                          src={logoNoText}
                          width="18px"
                          style={{paddingBottom: "0px"}}
                          className="d-inline-block align-middle logo-padding"
                          alt={"Datum Geospatial"}
                      />
                    </div>
                  </Button>
              </OverlayTrigger>   
              <OverlayTrigger placement="bottom" delay={{ show: 100, hide: 200 }} overlay={this.renderTooltip("Dashboard List")}>
                  <Button className="dashboard-icon-button" variant="secondary" key="dashboard-list" href={"/"}>
                    {/*<FontAwesomeIcon icon={faThList} />*/}
                    <img
                        src={datumLogoNoText}
                        width="18px"
                        style={{paddingBottom: "3px"}}
                        className="d-inline-block align-middle logo-padding"
                        alt={"Datum Geospatial"}
                    />
                  </Button>
              </OverlayTrigger>    
              {( _currentUser.roleId === ROLE_ADMIN ) &&
              <>
              <OverlayTrigger placement="bottom" delay={{ show: 100, hide: 200 }} overlay={this.renderTooltip("Data")}>
                  <Button className="dashboard-icon-button" variant="secondary" key="admin" href={"/data/settings"}><FontAwesomeIcon icon={faLayerGroup} /></Button>
              </OverlayTrigger>
              <OverlayTrigger placement="bottom" delay={{ show: 100, hide: 200 }} overlay={this.renderTooltip("Admin")}>
                  <Button className="dashboard-icon-button" variant="secondary" key="admin" href={"/org/profile"}><FontAwesomeIcon icon={faCog} /></Button>
              </OverlayTrigger>
              </>}
              </span>
    }else{
      return '';
    }
  }

  async handleOrgSwitch(userOrg: any) {
    console.log('handleOrgSwitch', userOrg);
    console.log("this.props.history", this.props.history) // dashboard list || dashboard
    await this.props.refreshAllCredentials(userOrg.orgId);
    this.props.history.push("/switchOrgsFromDashboard");
  }

  renderDashboardOptions() {
    const { showDashboardOptions, showCreateDashboardOption, currentUser, userOrgs } = this.props;
    let dashboardActionElement:any = '';

    let currentUserName = "Guest";
    let loginLogoutElement;

    let orgSwitcherElement;

    if (userOrgs && userOrgs.length) {
      console.log('currentUser: ', this.props.currentUser);
      let currentUserOrgId: any;
      if (this.props.currentUser) {
        currentUserOrgId = this.props.currentUser.orgId;
      }
      orgSwitcherElement = userOrgs.map((userOrg: any, i: number) => {
        return (
          <Dropdown.Item onClick={() => this.handleOrgSwitch(userOrg)} key={i} active={currentUserOrgId === userOrg.orgId}>
            {userOrg.orgName}
          </Dropdown.Item>
        );
      });
    }

    // If current user exists and has an id
    if (currentUser && currentUser.userId) {
      currentUserName = currentUser.userName;
      loginLogoutElement = (
        <Dropdown.Item eventKey="1" href="/logout">
          <FontAwesomeIcon icon={faSignOutAlt} /> Logout
        </Dropdown.Item>
      );
    } else {
      loginLogoutElement = (
        <Dropdown.Item eventKey="1" href="/login">
          <FontAwesomeIcon icon={faSignInAlt} /> Login
        </Dropdown.Item>
      );
    }
    return (
      <div className="w-30 text-right">
        <Form className="dashboard-actions">
          {showCreateDashboardOption &&
            this.renderAdminButtons(currentUser)
          }
        </Form>
        <div className="dashboard-admin">
          {showDashboardOptions &&
            this.renderAdminButtons(currentUser)
          }
        </div>
        {dashboardActionElement}
        <Dropdown alignRight className="dropdown profile">
          <Dropdown.Toggle variant="secondary	" id="profile-dropdown">
            <FontAwesomeIcon icon={faUser} /> {currentUserName}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {loginLogoutElement}
            {currentUser && currentUser.userId && orgSwitcherElement ?
              <span><Dropdown.Divider/>{orgSwitcherElement}</span>
              : null}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }

  render() {
    console.log("113021 this.props.currentUser", this.props.currentUser)
    console.log("113021 this.props", this.props)
    const { dashboardName } = this.props;
    return (
      <Navbar variant="dark" sticky="top" bg="dark" expand="lg" id="header" className="justify-content-between">
        <Logo currentUser={this.props.currentUser} context={"dashboard"} />
        <Navbar.Collapse className="justify-content-center">
          {dashboardName &&
          <Nav className="mr-auto text-center text-nowrap">
            <span className="h4 m-0 dashboard-title">{dashboardName || 'Unknown'}</span>
          </Nav>
          }
        </Navbar.Collapse>
        {this.renderDashboardOptions()}
      </Navbar>
    );
  }
}

export default withRouter(Navigation);
